import { FC, useEffect, useState } from "react";
import styles from "./Interface.module.scss";
import clsx from "clsx";
import { EnvironmentIcon } from "../../assets/svg/EnvironmentIcon";
import { ObjectIcon } from "../../assets/svg/ObjectIcon";
import { QualityButton } from "./components/QualityButton/QualityButton";
import { Environments } from "./components/Environments/Environments";
import { Objects } from "./components/Objects/Objects";
import { EnvironmentItem } from "./components/Environments/components/EnvironmentItem/EnvironmentItem";
import { useURLRouting } from "../../utils/hooks/useURLRouting";
import { RenderImageButton } from "./components/RenderImageButton/RenderImageButton";
import { ObjectOptionsItem } from "./components/Objects/components/ObjectItem/ObjectOptionsItem";
import { useAppSelector } from "../../redux/store";
import { getActiveObjectId } from "../../redux/reducers/ui/selectors/objectSelectors";

export enum EActiveTab {
  Environment = "environment",
  Object = "object",
}

export const Interface: FC = () => {
  const { currentView, activeTab, setTab, setItem } = useURLRouting();
  const [currentTab, setCurrentTab] = useState<EActiveTab>(
    EActiveTab.Environment
  );
  const isShowInterfaceContent =
    currentView && currentTab && !currentView.list_id;
  const isShowEnvironmentItem =
    currentView &&
    currentView.list_id &&
    currentView.list_id >= "0" &&
    currentTab === EActiveTab.Environment;
  const isShowObjectItem =
    currentView &&
    currentView.list_id &&
    currentView.list_id >= "0" &&
    currentTab === EActiveTab.Object;

  const activeObjectId = useAppSelector(getActiveObjectId);

  console.log("isShowEnvironmentItem " + isShowEnvironmentItem);

  useEffect(() => {
    if (currentView) {
      if (activeTab === EActiveTab.Environment) {
        setCurrentTab(EActiveTab.Environment);
      } else {
        setCurrentTab(EActiveTab.Object);
      }
    }
  }, []);

  useEffect(() => {
    if (!activeObjectId) {
      if (activeTab === EActiveTab.Object) {
        setItem("");
      }

      return;
    }

    if (activeObjectId) {
      setCurrentTab(EActiveTab.Object);
      setTab(EActiveTab.Object);
      setItem(activeObjectId);
    }
  }, [activeObjectId]);

  const handleRedirectToEnvironments = () => {
    setCurrentTab(EActiveTab.Environment);
    setTab(EActiveTab.Environment);
  };

  const handleRedirectToObject = () => {
    setCurrentTab(EActiveTab.Object);
    setTab(EActiveTab.Object);
  };

  return (
    <div className={styles.wrapper} id="interface">
      {isShowInterfaceContent ? (
        <>
          <div className={styles.tab_wrapper} data-tour="tab-block">
            <button
              onClick={handleRedirectToEnvironments}
              className={clsx({
                [styles.active]: currentTab === EActiveTab.Environment,
              })}
              data-tour="tab-enviroments"
            >
              <EnvironmentIcon /> Environments
            </button>
            <button
              onClick={handleRedirectToObject}
              className={clsx({
                [styles.active]: currentTab === EActiveTab.Object,
              })}
              data-tour="tab-objects"
            >
              <ObjectIcon /> Objects
            </button>
          </div>
          <div className={styles.content}>
            {currentTab === EActiveTab.Environment ? (
              <Environments />
            ) : (
              <Objects />
            )}
          </div>
        </>
      ) : null}

      {isShowEnvironmentItem ? <EnvironmentItem /> : null}

      {isShowObjectItem ? <ObjectOptionsItem /> : null}

      <div className={styles.footer}>
        {/* <button><QualityIcon/> Quality</button> */}
        <QualityButton />
        <RenderImageButton />
        {/* <InterfaceWidgets /> */}
      </div>
      {/* <ServerStatus status={serverStatus} /> */}
      {/* <div className={s.titleWrapper}>
        <div className={s.title}>Select category</div>
        <LogoWithText />
      </div> */}
      {/* // env, obj */}
      {/* <ComponentNavigator /> */}
      {/* // full screen, reset, renderImage */}
      {/* <InterfaceWidgets /> */}
    </div>
  );
};
